import { useEventSubscribe } from '../events';
import { useDraftComments, draftCommentsStorage } from './useDraftComments';
import { commentService } from '../services/commentService';
export function useDraftCommentPromotion(projectId) {
    const draftComments = useDraftComments(projectId || '');
    useEventSubscribe('userArtifact:promoted', async (payload) => {
        if (!projectId || payload.projectId !== projectId)
            return;
        const matchingDrafts = draftCommentsStorage.getDraftsForUnsavedItem(projectId, payload.unsavedItemId);
        if (matchingDrafts.length === 0)
            return;
        for (const draft of matchingDrafts) {
            try {
                if (!payload.anchor) {
                    // Top-level comments require an anchor under the new model. Skip
                    // drafts whose promoted artifact didn't carry one (paths, polygons,
                    // highlights) — the user can re-add a coord-anchored comment instead.
                    console.warn('[MapViewer] Skipping draft promotion: artifact has no anchor coord', {
                        artifactId: payload.savedArtifactId,
                        artifactType: payload.savedArtifactType,
                    });
                    continue;
                }
                await commentService.createComment({
                    projectId: payload.projectId,
                    content: draft.content,
                    scopeId: draft.scopeId,
                    artifactIds: [payload.savedArtifactId],
                    anchor: payload.anchor,
                });
            }
            catch (err) {
                console.error('[MapViewer] Failed to promote draft comment:', err);
            }
        }
        draftCommentsStorage.clearDraftsForItem(projectId, payload.unsavedItemId);
        draftComments.clearDraftsForItem(payload.unsavedItemId);
    }, [projectId, draftComments.clearDraftsForItem]);
}
